<template>
  <div class="">
    <!-- ======= start: viber floating icon ======= -->
    <div>
      <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/font-awesome/4.5.0/css/font-awesome.min.css">
      <a href="https://msng.link/vi/09151471977" class="viber-float" target="_blank">
          <svg xmlns="http://www.w3.org/2000/svg" width="36.034" height="38.059" class="my-viber-float" viewBox="0 0 36.034 38.059">
            <path id="Path_974" data-name="Path 974" d="M32.953-29.539q2.449,2.152,3.488,6.791a34.594,34.594,0,0,1,.223,11.467,16.035,16.035,0,0,1-.705,3.117,13,13,0,0,1-1.076,2.412A10.021,10.021,0,0,1,33.51-3.934a9.586,9.586,0,0,1-1.484,1.3,10.058,10.058,0,0,1-1.521.854q-.816.371-1.336.557a10.751,10.751,0,0,1-1.15.334,7.141,7.141,0,0,1-.705.148A9.028,9.028,0,0,1,25.531-.3q-1.262.223-4.008.482A27.166,27.166,0,0,1,16.031.148Q14.473,1.855,13.8,2.6q-.223.223-.594.631t-.52.557l-.482.482q-.334.334-.482.334a1.7,1.7,0,0,0-.52.148q-.371.148-.52-.074a1.1,1.1,0,0,1-.52-.3,1.116,1.116,0,0,1-.3-.482,3.894,3.894,0,0,1-.111-.52,3.068,3.068,0,0,1-.037-.408L9.648,2.82l.074-3.859H9.648A12.572,12.572,0,0,1,6.754-2.264,8.827,8.827,0,0,1,4.564-4.008,15.062,15.062,0,0,1,3.006-6.123,9.28,9.28,0,0,1,1.967-8.461q-.334-1.188-.594-2.449a14.369,14.369,0,0,1-.3-2.449Q1.039-14.547,1-15.66a17.362,17.362,0,0,1,.037-2q.148-8.09,3.711-11.652a13.972,13.972,0,0,1,5.938-2.969,25.973,25.973,0,0,1,6.383-.965h2.6a31.831,31.831,0,0,1,7.014.854,17.891,17.891,0,0,1,4.342,1.484A12.252,12.252,0,0,1,32.953-29.539Zm1.039,17.59a29.912,29.912,0,0,0-.111-9.834,10.216,10.216,0,0,0-2.932-5.826,7.055,7.055,0,0,0-1.633-1.113,16.37,16.37,0,0,0-3.822-1.187,31.276,31.276,0,0,0-5.975-.668h-.928q-.631,0-2.3.111A31.367,31.367,0,0,0,13.1-30.1a16.689,16.689,0,0,0-3.3.965A8.4,8.4,0,0,0,6.9-27.312Q3.859-24.344,3.711-17.59a27.492,27.492,0,0,1,0,2.857,12.733,12.733,0,0,0,.3,3.266,18.633,18.633,0,0,0,1,3.266,7.7,7.7,0,0,0,2.115,2.82,9.107,9.107,0,0,0,3.637,1.893q-.074,5.863-.074,6.383t.3.631q.3.111.594-.26L16.625-2.6A32.831,32.831,0,0,0,21.3-2.635a32.571,32.571,0,0,0,3.488-.408,14.892,14.892,0,0,0,1.559-.371,7.141,7.141,0,0,0,.705-.148A8.62,8.62,0,0,0,28.166-3.9q.482-.186,1.3-.557a4.894,4.894,0,0,0,1.447-1,16.364,16.364,0,0,0,1.3-1.484,7.321,7.321,0,0,0,1.113-2.152A15.619,15.619,0,0,0,33.992-11.949ZM23.676-17.961q0,.52-.482.52t-.482-.445a2.384,2.384,0,0,0-2.449-2.523.407.407,0,0,1-.408-.26.48.48,0,0,1,.037-.482.5.5,0,0,1,.445-.223Q23.527-21.227,23.676-17.961Zm1.484.891a5.573,5.573,0,0,0-1.41-4.082,6.136,6.136,0,0,0-4.23-1.855.344.344,0,0,1-.371-.26.646.646,0,0,1,.037-.482.415.415,0,0,1,.408-.223,6.924,6.924,0,0,1,4.861,2.152,6.552,6.552,0,0,1,1.67,4.75.415.415,0,0,1-.223.408.55.55,0,0,1-.482,0A.407.407,0,0,1,25.16-17.07Zm3.488.965a.415.415,0,0,1-.223.408.55.55,0,0,1-.482,0,.407.407,0,0,1-.26-.408,9.125,9.125,0,0,0-2.561-6.865,8.846,8.846,0,0,0-6.42-2.486q-.445,0-.445-.482t.445-.482a9.726,9.726,0,0,1,7.125,2.783A10.1,10.1,0,0,1,28.648-16.105Zm-.816,7.273a6.845,6.845,0,0,1-1.781,2.041,2.123,2.123,0,0,1-2.078.408,20.742,20.742,0,0,1-3.6-1.633A29.2,29.2,0,0,1,16.4-10.539a19.473,19.473,0,0,1-3.191-3.191,29.017,29.017,0,0,1-2.227-3.414q-.742-1.262-1.225-2.3T9.129-20.93L9.055-21.3a2.123,2.123,0,0,1,.408-2.078A6.845,6.845,0,0,1,11.5-25.16a1.364,1.364,0,0,1,1.781.3q.891,1.113,1.336,1.633.52.742,1.113,1.781a1.421,1.421,0,0,1-.3,2l-.891.668a.71.71,0,0,0-.3.408,1.763,1.763,0,0,0-.074.482v.148l.186.557a11,11,0,0,0,.594,1.262,10.134,10.134,0,0,0,1.113,1.707,8.938,8.938,0,0,0,1.781,1.6A7.824,7.824,0,0,0,20.41-11.43a1.278,1.278,0,0,0,1.039-.445l.742-.891a1.342,1.342,0,0,1,1.93-.3,17.89,17.89,0,0,1,3.414,2.449A1.364,1.364,0,0,1,27.832-8.832Z" transform="translate(-0.99 33.25)" fill="#fff"/>
          </svg>
      </a>
    </div>
    <!-- ======= end: viber floating icon ======= -->
    <div class="w-full header-nav-wrapper">
      <div class="container lg:px-0">
          <div class="flex items-center py-2">
              <div class="w-3/6 w-2/6 lg:w-1/6">
                <router-link class="m-auto" to="/"><img width="140" src="/images/logo.png"></a></router-link>
              </div>
              <div class="w-2/6 hidden lg:block"></div>
              <div class="w-3/6 md:w-4/6 lg:w-3/6 hidden md:block">
                <div class="w-full text-left flex items-center justify-start">
                  <div class="pr-3"><img width="96" src="/images/header-icon-map.png"></div>
                  <div class="text-common text-white">
                    <span class="text-blue-200">OFFICE ADDRESS</span><br>
                    <span class="font-medium">Unit 101 LCC Bldg. 38D Mercedes Ave., Barangay. San Miguel Pasig City. (showroom)</span>
                  </div>
                </div>
              </div>
              <div class="w-3/6 lg:w-2/6 text-left flex items-center justify-center">
                <div class="hidden md:block pr-1"><img src="/images/header-icon-phone.png"></div>
                <div class="text-common text-white">
                  <span class="text-blue-200">CONTACT US AT</span><br>
                  <a class="tel" href="tel:09151471977">09151471977</a><br>
                  <a class="tel" href="tel:09226850003">09226850003</a><br>
                  <a class="tel" href="tel:0277993089">(02) 7799 3089</a><br>
                  <a class="tel" href="tel:0286521240">(02) 8652 1240</a>
                </div>
              </div>
          </div>
        </div>


        <!-- ================ navigation menu ===================== -->
          <div class="w-full hidden md:block md:border-t-2 md:border-blue-700"></div>
          <div class="w-full">
            <div class="container">
              <!-- Mobile Menu -->
              <div class="header-menu-btn block md:hidden">
                <button id="navMenuBtn" class="flex justify-center bg-blue-700 product-btn w-full text-md text-center text-white font-bold tracking-wider hover:bg-yellow-800 duration-300 px-5 pt-2 pb-2">
                  NAVIGATION MENU &nbsp; <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"></path></svg>
                </button>
              </div>
              <div id="navMenu" class="w-full mobile-menu md:hidden bg-white md:flex header-menu text-center md:text-left">
                <div class="w-full bg-blue-700 font-bold pt-4 pb-4">
                  <div class="closeMenu flex justify-center"><span class="text-white pt-1">ClOSE MENU</span>&nbsp;&nbsp;<div class="close-modal">&times;</div></div>
                </div>
                <div class="py-2 lg:pr-4 mt-8 md:mt-0">
                  <a href="#products" class="closeMenu01 text-md lg:text-lg text-center text-gray-800 font-medium tracking-wide bg-white hover:bg-yellow-400 hover:text-white duration-300 px-2 py-2">
                    Our Products
                  </a>
                </div>
                <div class="py-2 lg:pr-4">
                  <a href="#projects" class="closeMenu02 text-md lg:text-lg text-center text-gray-800 font-medium tracking-wide bg-white hover:bg-yellow-400 hover:text-white duration-300 px-2 py-2">
                    Our Projects
                  </a>
                </div>
                <div class="py-2 lg:pr-4">
                  <a href="#about" class="closeMenu03 text-md lg:text-lg text-center text-gray-800 font-medium tracking-wide bg-white hover:bg-yellow-400 hover:text-white duration-300 px-2 py-2">
                    About Us
                  </a>
                </div>
                <div class="py-2 lg:pr-4">
                  <a href="#contact" class="closeMenu04 text-md lg:text-lg text-center text-gray-800 font-medium tracking-wide bg-white hover:bg-yellow-400 hover:text-white duration-300 px-2 py-2">
                    Inquire Now
                  </a>
                </div>
              </div>
              <!-- tablet & Desktop Menu -->
              <!-- <div class="w-full hidden lg:block mt-1 pt-2"></div> -->
              <div class="w-full hidden md:block md:flex header-menu text-center md:text-left">
                <div class="py-2 lg:pr-4 mt-8 md:mt-0">
                  <a href="#products" class="text-md lg:text-lg text-center text-white font-medium tracking-wide hover:bg-blue-700 hover:text-white duration-300 px-2 py-2">
                    Our Products
                  </a>
                </div>
                <div class="text-md lg:text-lg text-center text-yellow-300 font-medium tracking-wide hidden md:block lg:pr-4 py-2">|</div>
                <div class="py-2 lg:pr-4">
                  <a href="#projects" class="text-md lg:text-lg text-center text-white font-medium tracking-wide hover:bg-blue-700 hover:text-white duration-300 px-2 py-2">
                    Our Projects
                  </a>
                </div>
                <div class="text-md lg:text-lg text-center text-yellow-300 font-medium tracking-wide hidden md:block lg:pr-4 py-2">|</div>
                <div class="py-2 lg:pr-4">
                  <a href="#about" class="text-md lg:text-lg text-center text-white font-medium tracking-wide hover:bg-blue-700 hover:text-white duration-300 px-2 py-2">
                    About Us
                  </a>
                </div>
                <div class="text-md lg:text-lg text-center text-yellow-300 font-medium tracking-wide hidden md:block lg:pr-4 py-2">|</div>
                <div class="py-2 lg:pr-4">
                  <a href="#contact" class="text-md lg:text-lg text-center text-white font-medium tracking-wide hover:bg-blue-700 hover:text-white duration-300 px-2 py-2">
                    Inquire Now
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      


  </div>
</template>

<script>
export default {
  name: 'Headernav'
}
</script>

<style>
.header-nav-wrapper {
  /* background: url('/images/common-bg-blue.jpg') center top no-repeat #001e81; */
  background-color: rgba(20,45,127, 0.7);
	backdrop-filter: blur(3px);
  
  position: fixed;
  z-index: 99;
  padding: 0px 0px;
}
</style>
